import { VestingTermGradedRes } from '@dealstack/shared/lib/generated';

// Calculates the remaining percentage and prevents floating-point errors.
export const getRemainingVestingPercentage = (
	vestingTermGraded?: VestingTermGradedRes[]
): number => {
	const sumInCents = (vestingTermGraded || []).reduce(
		(acc, gradedTerm) => acc + Math.round(gradedTerm.percentage * 100),
		0
	);
	return (10000 - sumInCents) / 100;
};
